export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: process.env.REACT_APP_AZURE_AUTHORITY,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Scope used to acquire tokens for the DirectCharge API.
// Set REACT_APP_API_SCOPE in .env to something like:
//   api://<api-client-id>/access_as_user
const apiScope = process.env.REACT_APP_API_SCOPE;

export const loginRequest = {
  scopes: ["User.Read", ...(apiScope ? [apiScope] : [])],
};

export const apiRequest = {
  scopes: apiScope ? [apiScope] : [],
};
